const state = {
  psPrice: null,
  psId: null,
  psTotal: null,
  psName: null,
  psIsSaved: null,
  psFromValueModel: null,
  psToValueModel: null,

  psFromYearModel: null,
  psToYearModel: null,

  psFromRevenueModel: null,
  psToRevenueModel: null,
  psContactStreetAddr: null,
  psContactName: null,
  psContactPhone: null,
  psEmployeeCount: null,
  psRadioFranchise: null,
  psRadioWebPresense: null,
  psRadioSocialPresense: null,
  psYearsInBusiness: 25,
  psAllRecords: null,

  psCreditsAvailable: null,
  psCreditsTotal: null,
  psCreditsUsed: null,

  psTotalResult: null,
};

const mutations = {
  PS_SET_PRICE: (state, psPrice) => {
    state.psPrice = psPrice;
  },
  PS_SET_ID: (state, psId) => {
    state.psId = psId;
  },
  PS_SET_TOTAL: (state, psTotal) => {
    state.psTotal = psTotal;
  },
  PS_SET_NAME: (state, psName) => {
    state.psName = psName;
  },
  PS_SET_IS_SAVED: (state, psIsSaved) => {
    state.psIsSaved = psIsSaved;
  }, 
  PS_SET_FROM_VALUE_MODEL:(state, psFromValueModel)=>{
    state.psFromValueModel = psFromValueModel;
  },
  PS_SET_TO_VALUE_MODEL:(state, psToValueModel )=>{
    state.psToValueModel = psToValueModel;
  },

  PS_SET_FROM_YEAR_MODEL:(state, psFromYearModel)=>{
    state.psFromYearModel = psFromYearModel;
  },
  PS_SET_TO_YEAR_MODEL:(state, psToYearModel )=>{
    state.psToYearModel = psToYearModel;
  },

  PS_SET_FROM_REVENUE_MODEL:(state, psFromRevenueModel)=>{
    state.psFromRevenueModel = psFromRevenueModel;
  },
  PS_SET_TO_REVENUE_MODEL:(state, psToRevenueModel)=>{
    state.psToRevenueModel = psToRevenueModel;
  },
  PS_SET_CONTACT_STREET_ADDR:(state, psContactStreetAddr)=>{
    state.psContactStreetAddr = psContactStreetAddr;
  },
  PS_SET_CONTACT_NAME:(state, psContactName)=>{
    state.psContactName = psContactName;
  },
  PS_SET_CONTACT_PHONE:(state, psContactPhone)=>{
    state.psContactPhone = psContactPhone;
  },
  PS_SET_EMPLOYEE_COUNT:(state, psEmployeeCount)=>{
    state.psEmployeeCount = psEmployeeCount;
  },
  PS_SET_RADIO_FRANCHISE:(state, psRadioFranchise)=>{
    state.psRadioFranchise = psRadioFranchise;
  },
  PS_SET_RADIO_WEB_PRESENSE:(state, psRadioWebPresense)=>{
    state.psRadioWebPresense = psRadioWebPresense;
  },
  PS_SET_RADIO_SOCIAL_PRESENSE:(state, psRadioSocialPresense)=>{
    state.psRadioSocialPresense = psRadioSocialPresense;
  },
  PS_SET_YEARS_IN_BUSINESS:(state, psYearsInBusiness)=>{
    state.psYearsInBusiness = psYearsInBusiness;
  },
  PS_SET_ALL_RECORDS:(state, psAllRecords)=>{
    state.psAllRecords = psAllRecords;
  },  
  PS_SET_CREDITS_AVAILABLE:(state, psCreditsAvailable)=>{
    state.psCreditsAvailable = psCreditsAvailable;
  }, 
  PS_SET_CREDITS_TOTAL:(state, psCreditsTotal)=>{
    state.psCreditsTotal = psCreditsTotal;
  }, 
  PS_SET_CREDITS_USED:(state, psCreditsUsed)=>{
    state.psCreditsUsed = psCreditsUsed;
  }, 

  PS_SET_TOTAL_RESULT:(state, psTotalResult)=>{
    state.psTotalResult = psTotalResult;
  }, 
};

const getters = { 
psPrice: (state) => state.psPrice,
psId: (state) => state.psId,
psTotal: (state) => state.psTotal,
psName: (state) => state.psName,
psIsSaved: (state) => state.psIsSaved,  
psFromValueModel: (state) => state.psFromValueModel,  
psToValueModel: (state) => state.psToValueModel,

psFromYearModel: (state) => state.psFromYearModel,
psToYearModel: (state) => state.psToYearModel,

psFromRevenueModel: (state) => state.psFromRevenueModel,  
psToRevenueModel: (state) => state.psToRevenueModel,  
psContactStreetAddr: (state) => state.psContactStreetAddr,  
psContactName: (state) => state.psContactName,  
psContactPhone: (state) => state.psContactPhone,  
psEmployeeCount: (state) => state.psEmployeeCount,  
psRadioFranchise: (state) => state.psRadioFranchise,  
psRadioWebPresense: (state) => state.psRadioWebPresense,  
psRadioSocialPresense: (state) => state.psRadioSocialPresense,  
psAllRecords: (state) => state.psAllRecords,  
psYearsInBusiness: (state) => state.psYearsInBusiness,  

psCreditsAvailable: (state) => state.psCreditsAvailable,
psCreditsTotal: (state) => state.psCreditsTotal,
psCreditsUsed: (state) => state.psCreditsUsed,

psTotalResult: (state) => state.psTotalResult,
};

const prospectSearch = {
state,
getters,
mutations,
};

export default prospectSearch;